import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AccountSelectorDropDown from "./AccountSelectorDropDown";
import ReactGA from 'react-ga4';
interface TabPanelProps {
  children?: React.ReactNode;
  content: any;
  value?: any;
  onChange?: any; // Make the function optional
}

function a11yProps(index: number) {   
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CustomTabs: React.FC<TabPanelProps> = ({ value, content, onChange }) => {
  // const [value, setValue] = React.useState(0);

  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };

  return (
    <Box>
      <div className="tab-contaner">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={onChange}
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: { backgroundColor: "rgba(0, 179, 181, 1)" },
            }}
          >
            {content?.map((elem: any) => (
              <Tab
                key={elem.index}
                label={elem.label}
                {...a11yProps(elem.index)}
                sx={{
                  textTransform: "none",
                  fontSize: "13px",
                  lineHeight: "23px",
                  fontWeight: 400,
                  "&.Mui-selected": {
                    color: "rgba(0, 179, 181, 1)",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>
        <AccountSelectorDropDown
          labelText="Loan account number"
          buttonText=" N/A"
          isActive={""}
        />
      </div>
    </Box>
  );
};
export default CustomTabs;
